import React from 'react';

const USA = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_45916)">
      <rect width="28" height="20" rx="3" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V9.33333H0V0Z" fill="#1A47B8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0V1.33333H28V0H12ZM12 2.66667V4H28V2.66667H12ZM12 5.33333V6.66667H28V5.33333H12ZM12 8V9.33333H28V8H12ZM0 10.6667V12H28V10.6667H0ZM0 13.3333V14.6667H28V13.3333H0ZM0 16V17.3333H28V16H0ZM0 18.6667V20H28V18.6667H0Z"
        fill="#F93939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3335 1.3335V2.66683H2.66683V1.3335H1.3335ZM4.00016 1.3335V2.66683H5.3335V1.3335H4.00016ZM6.66683 1.3335V2.66683H8.00016V1.3335H6.66683ZM9.3335 1.3335V2.66683H10.6668V1.3335H9.3335ZM8.00016 2.66683V4.00016H9.3335V2.66683H8.00016ZM5.3335 2.66683V4.00016H6.66683V2.66683H5.3335ZM2.66683 2.66683V4.00016H4.00016V2.66683H2.66683ZM1.3335 4.00016V5.3335H2.66683V4.00016H1.3335ZM4.00016 4.00016V5.3335H5.3335V4.00016H4.00016ZM6.66683 4.00016V5.3335H8.00016V4.00016H6.66683ZM9.3335 4.00016V5.3335H10.6668V4.00016H9.3335ZM1.3335 6.66683V8.00016H2.66683V6.66683H1.3335ZM4.00016 6.66683V8.00016H5.3335V6.66683H4.00016ZM6.66683 6.66683V8.00016H8.00016V6.66683H6.66683ZM9.3335 6.66683V8.00016H10.6668V6.66683H9.3335ZM8.00016 5.3335V6.66683H9.3335V5.3335H8.00016ZM5.3335 5.3335V6.66683H6.66683V5.3335H5.3335ZM2.66683 5.3335V6.66683H4.00016V5.3335H2.66683Z"
        fill="white"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_45916">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default USA;
